import axios, { AxiosError } from "axios";
import { apiQuery } from "./baseurl";
import { ExceptionService, ToastService } from "../services";
import { SKIP_ERROR_URL } from "./models";

const authQuery = axios.create({
  baseURL: apiQuery,
});

authQuery.interceptors.request.use((config) => {
  config.headers.Authorization = "Basic aHR0cHVzZXI6aHR0cHVzZXI=";

  return config;
});

authQuery.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    ToastService.onDanger({
      title: ExceptionService.errorResolver(error.response?.data),
    });

    return Promise.reject(error);
  }
);

const baseQuery = axios.create({
  baseURL: apiQuery,
});

const exceptionQuery = axios.create({
  baseURL: apiQuery,
});

baseQuery.interceptors.request.use((config) => {
  config.headers.Authorization = "Basic aHR0cHVzZXI6aHR0cHVzZXI=";

  return config;
});

baseQuery.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const url = error.response?.config.url;

    const shouldSkipError =
      url &&
      Object.keys(SKIP_ERROR_URL).some((baseUrl) => url.startsWith(baseUrl));

    if (!shouldSkipError) {
      ToastService.onDanger({
        title: ExceptionService.errorResolver(error.response?.data),
      });
    }

    return Promise.reject(error);
  }
);

export { authQuery, baseQuery, exceptionQuery };
